import { useReducer } from 'react'

const ACTIONS = {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  SET_AUTOMATIONS: 'SET_AUTOMATIONS',
  SET_DISPOSITIONS: 'SET_DISPOSITIONS',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  SET_SMS_HISTORY: 'SET_SMS_HISTORY',
  SET_SMS_HISTORY_META: 'SET_SMS_HISTORY_META',
  SET_TAB_VALUE: 'SET_TAB_VALUE',
  SET_CAMPAIGN_SEARCH_TERM: 'SET_CAMPAIGN_SEARCH_TERM',
  TOGGLE_DIALOG: 'TOGGLE_DIALOG',
  SET_SELECTED_AUTOMATION: 'SET_SELECTED_AUTOMATION',
  SET_NEW_AUTOMATION: 'SET_NEW_AUTOMATION',
  RESET_NEW_AUTOMATION: 'RESET_NEW_AUTOMATION',
  UPDATE_AUTOMATION_ENABLED: 'UPDATE_AUTOMATION_ENABLED',
  SET_SMS_SETTINGS: 'SET_SMS_SETTINGS'
}

const initialState = {
  automations: [],
  dispositions: [],
  campaigns: [],
  smsHistory: [],
  smsHistoryMeta: { total: 0, page: 1, totalPages: 1 },
  smsSettings: { override_enabled: false, override_to_number: '' },

  loading: true,
  error: null,
  tabValue: 0,
  campaignSearchTerm: '',

  selectedAutomation: null,

  createDialogOpen: false,
  editDialogOpen: false,
  campaignsDialogOpen: false,
  testDialogOpen: false,

  newAutomation: {
    name: '',
    type: 'sms_on_disposition',
    enabled: true,
    config: {
      trigger: { disposition: '' },
      sms: { template: '' }
    }
  }
}

function smsAutomationReducer (state, action) {
  switch (action.type) {
    case ACTIONS.SET_LOADING:
      return { ...state, loading: action.payload }
    case ACTIONS.SET_ERROR:
      return { ...state, error: action.payload }
    case ACTIONS.SET_AUTOMATIONS:
      return { ...state, automations: action.payload }
    case ACTIONS.SET_DISPOSITIONS:
      return { ...state, dispositions: action.payload }
    case ACTIONS.SET_CAMPAIGNS:
      return { ...state, campaigns: action.payload }
    case ACTIONS.SET_SMS_HISTORY:
      return { ...state, smsHistory: action.payload }
    case ACTIONS.SET_SMS_HISTORY_META:
      return { ...state, smsHistoryMeta: action.payload }
    case ACTIONS.SET_TAB_VALUE:
      return { ...state, tabValue: action.payload }
    case ACTIONS.SET_CAMPAIGN_SEARCH_TERM:
      return { ...state, campaignSearchTerm: action.payload }
    case ACTIONS.TOGGLE_DIALOG:
      return { ...state, [action.payload.dialog]: action.payload.open }
    case ACTIONS.SET_SELECTED_AUTOMATION:
      return { ...state, selectedAutomation: action.payload }
    case ACTIONS.SET_NEW_AUTOMATION:
      return { ...state, newAutomation: { ...state.newAutomation, ...action.payload } }
    case ACTIONS.RESET_NEW_AUTOMATION:
      return { ...state, newAutomation: initialState.newAutomation }
    case ACTIONS.SET_SMS_SETTINGS:
      return { ...state, smsSettings: action.payload }
    case ACTIONS.UPDATE_AUTOMATION_ENABLED:
      return {
        ...state,
        automations: state.automations.map(a =>
          a.id === action.payload.automationId
            ? { ...a, enabled: action.payload.enabled }
            : a
        )
      }
    default:
      return state
  }
}

export const useSmsAutomationReducer = () => {
  const [state, dispatch] = useReducer(smsAutomationReducer, initialState)

  const actions = {
    setLoading: (loading) => dispatch({ type: ACTIONS.SET_LOADING, payload: loading }),
    setError: (error) => dispatch({ type: ACTIONS.SET_ERROR, payload: error }),
    setAutomations: (automations) => dispatch({ type: ACTIONS.SET_AUTOMATIONS, payload: automations }),
    setDispositions: (dispositions) => dispatch({ type: ACTIONS.SET_DISPOSITIONS, payload: dispositions }),
    setCampaigns: (campaigns) => dispatch({ type: ACTIONS.SET_CAMPAIGNS, payload: campaigns }),
    setSmsHistory: (history) => dispatch({ type: ACTIONS.SET_SMS_HISTORY, payload: history }),
    setSmsHistoryMeta: (meta) => dispatch({ type: ACTIONS.SET_SMS_HISTORY_META, payload: meta }),
    setTabValue: (value) => dispatch({ type: ACTIONS.SET_TAB_VALUE, payload: value }),
    setCampaignSearchTerm: (term) => dispatch({ type: ACTIONS.SET_CAMPAIGN_SEARCH_TERM, payload: term }),
    toggleDialog: (dialog, open) => dispatch({ type: ACTIONS.TOGGLE_DIALOG, payload: { dialog, open } }),
    setSelectedAutomation: (automation) => dispatch({ type: ACTIONS.SET_SELECTED_AUTOMATION, payload: automation }),
    updateNewAutomation: (updates) => dispatch({ type: ACTIONS.SET_NEW_AUTOMATION, payload: updates }),
    resetNewAutomation: () => dispatch({ type: ACTIONS.RESET_NEW_AUTOMATION }),
    setSmsSettings: (settings) => dispatch({ type: ACTIONS.SET_SMS_SETTINGS, payload: settings }),
    updateAutomationEnabled: (automationId, enabled) =>
      dispatch({ type: ACTIONS.UPDATE_AUTOMATION_ENABLED, payload: { automationId, enabled } })
  }

  return [state, actions]
}

export default useSmsAutomationReducer
